import { object, string } from 'yup';

export default object().shape({
  phone: string()
    .required('Enter your phone')
    .matches(
      /* only allow 10 digit phone number */
      /^[0-9]{10}$/,
      'Use format 6123334444'
    ),
});
